export default __webpack_public_path__ + "img/catIcon5.09356d35.svg";